<svelte:options accessors/>
<script>
    import NauiExplorer from "../../naui/pages/NauiExplorer.svelte";
    import NauiButton from "../../naui/atoms/NauiButton.svelte";
    import {createEventDispatcher} from "svelte";

    export let data;
    export let columns;
    export let pages;
    export let filters;
    export let count;
    export let routeCreate;

    let explorerCmpt;

    const dispatch = createEventDispatcher()

    function descargarReporte() {
        dispatch('xlsx');
    }

    export let paginator = {
        total: pages,
        page: 1
    }

    export function getParams() {
        if (explorerCmpt) {
            return explorerCmpt.getParams();
        }
    }
</script>

<div>
    <NauiExplorer {data}
                  {pages}
                  {count}
                  {columns}
                  {filters} searchLabel="Buscar por servicio o cliente"
                  {paginator}
                  paginate={true}
                  on:filter
                  on:next
                  bind:this={explorerCmpt}>
        <div slot="actions">
            <div class="flex sx-iii">
                <NauiButton href="{routeCreate}" caption="REGISTRAR MOVIMIENTO" color="solid" mode="accent"
                            icon="plus"/>
                <NauiButton on:click={descargarReporte} caption="DESCARGAR REPORTE" mode="stroked"/>
            </div>
        </div>
    </NauiExplorer>
</div>
